import type { CandidateSource } from '@/types/candidates';

/**
 * The single source-of-truth list of candidate Source options, shared by the
 * New Candidate dialog and the profile Contact card so both stay in sync
 * (HW-705). Mirrors the CandidateSource enum on the backend.
 */
export const CANDIDATE_SOURCE_OPTIONS: Array<{ value: CandidateSource; label: string }> = [
  { value: 'LINKEDIN', label: 'LinkedIn' },
  { value: 'CAREER_SITE', label: 'Career Site' },
  { value: 'REFERRAL', label: 'Referral' },
  { value: 'DOU', label: 'DOU' },
  { value: 'DJINNI', label: 'Djinni' },
  { value: 'SMART_SOURCING', label: 'Smart Sourcing' },
  { value: 'OTHER', label: 'Other' },
];
